/**
 * Normalize a US/Canada phone number to E.164 format (+1XXXXXXXXXX).
 * Strips non-digit characters, prepends country code if missing.
 * Returns null if the input can't be normalized.
 */
export function normalizePhoneE164(value: string): string | null {
  const digits = value.replace(/[^\d]/g, '');
  const normalized =
    digits.startsWith('1') && digits.length === 11
      ? `+${digits}`
      : digits.length === 10
        ? `+1${digits}`
        : null;
  if (!normalized || !/^\+1\d{10}$/.test(normalized)) return null;
  return normalized;
}
